import React from "react";
import { Formik, Field } from "formik";
import { usDateFormat } from "../../../utils";
import { Button, Form } from "react-bootstrap";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
import { LoanStatementTable } from "./LoanStatement";
import { ContributionStatementTable } from "./ContributionStatement";
import { ParticipantLevelSourceTable } from "./ParticipantLevelSource";
import { ParticipantLoanAccountBalance } from "./ParticipantLoanAccountBalance";
import { ParticipantFeeStatement } from "./ParticipantFeeStatement";
import { ParticipantStatementTable } from "./ParticipantStatement";
import { ParticipantInvestmentTable } from "./ParticipantInvestmentStatement";
import { SourceLevelInvestmentTable } from "./SourceLevelInvestment";
import { StatementChangesinAssetsTable } from "./StatementofChangesinAssets";
const fields = {
  startDate: "startDate",
  endDate: "endDate",
  reportName: "reportName",
};
const reports = [
  {
    label: "Participant Statement",
    value: 1,
  },
  {
    label: "Contribution Statement",
    value: 2,
  },
  {
    label: "Loan Statement",
    value: 3,
  },
  {
    label: "Participant Investment Statement",
    value: 4,
  },
  {
    label: "Participant Loan account Balance report",
    value: 5,
  },
  {
    label: "Participant fee Statement",
    value: 6,
  },
  {
    label: "Participant level source report",
    value: 7,
  },
  {
    label: "Source level Investment report",
    value: 8,
  },
  {
    label: "Statement of changes in net assets for participant",
    value: 9,
  },
];

const Reports = (props) => {
  const FetchReport = (val) => {
    switch (val) {
      case 1:
        return <ParticipantStatementTable />;
      case 2:
        return <ContributionStatementTable />;
      case 3:
        return <LoanStatementTable />;
      case 4:
        return <ParticipantInvestmentTable />;
      case 5:
        return <ParticipantLoanAccountBalance />;
      case 6:
        return <ParticipantFeeStatement />;
      case 7:
        return <ParticipantLevelSourceTable />;
      case 8:
        return <SourceLevelInvestmentTable />;
      case 9:
        return <StatementChangesinAssetsTable />;
      default:
        return <ParticipantStatementTable />;
    }
  };
  const reportNameDisplay = (val) => {
    return reports.find((e) => e.value === val).label;
  };
  const onFormSubmit = () => {};
  return (
    <div>
      <Formik
        initialValues={{ [fields.reportName]: 1 }}
        onSubmit={onFormSubmit}
        enableReinitialize
      >
        {({ handleChange, setFieldValue, handleSubmit, values, ...rest }) => {
          const onDaySelected = (fieldName, value) => {
            setFieldValue(fieldName, value);
          };
          return (
            <>
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
              >
                <div className="d-flex" style={{ alignItems: "center" }}>
                  <div className="ml-3">
                    <Field
                      size="sm"
                      isRequired
                      label="Report Name"
                      name={fields.reportName}
                      value={reportNameDisplay(values[fields.reportName])}
                      placeholder="Select"
                      direction="bottom"
                      popupContent={
                        <SearchableList
                          options={reports}
                          onSelect={(value) =>
                            setFieldValue(fields.reportName, value)
                          }
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="ml-3">
                    <Button
                      type="button"
                      className="add-btn"
                      variant="secondary"
                      style={{
                        height: "fit-content",
                        fontSize: "0.75rem",
                        marginTop: "10%",
                      }}
                    >
                      This month
                    </Button>
                  </div>
                  <div className="ml-3">
                    <Button
                      type="button"
                      className="add-btn"
                      variant="secondary"
                      style={{
                        height: "fit-content",
                        fontSize: "0.75rem",
                        marginTop: "10%",
                      }}
                    >
                      Last month
                    </Button>
                  </div>
                  <div className="ml-3">
                    <Field
                      size="smd"
                      label="Start Date"
                      name={fields.startDate}
                      value={usDateFormat(values[fields.startDate])}
                      isDatePicker
                      onClear={() => onDaySelected(fields.startDate, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.startDate, value)
                          }
                          value={usDateFormat(values[fields.payDate])}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="ml-3">
                    <Field
                      size="smd"
                      label="End Date"
                      name={fields.endDate}
                      value={usDateFormat(values[fields.endDate])}
                      isDatePicker
                      onClear={() => onDaySelected(fields.endDate, null)}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.endDate, value)
                          }
                          value={usDateFormat(values[fields.endDate])}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                </div>
              </Form>
              <div>
                <div className="report-name-header">
                  {reportNameDisplay(values[fields.reportName])}
                </div>
                {FetchReport(values[fields.reportName])}
              </div>
            </>
          );
        }}
      </Formik>
    </div>
  );
};

export default Reports;
